$(document).ready(function() {

    const videoPlayer = $('.e-video-banner__video-iframe');

    if (videoPlayer.length > 0) {

        // get video type based on screen size
        if ($(window).width() < 551) {
            var src = videoPlayer.attr('data-src-mobile');
        } else {
            var src = videoPlayer.attr('data-src-desktop');
        }

        // set video src
        videoPlayer.attr('src', src);

    }

    function ResizeIframe() {

        var OldHeight = videoPlayer.height();
        var OldWidth = videoPlayer.width();
    
        if( OldWidth > OldHeight ) { // portrait
            // Get new height
            var newWidth = $('iframe').parent().width();		
            console.log(newWidth);
            var newHeight = ( OldHeight * newWidth ) / OldWidth;
            console.log(newHeight);
    
            // Assign to iframe
            videoPlayer.attr('width', newWidth);
            videoPlayer.attr('height', newHeight);
        }
    }
    
    ResizeIframe();

    $(window).resize( function() {
		ResizeIframe();
	});
});